module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-done-b61f056bb3105a0f8dec510743e209bc.svg";